'use client';

import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

type NavigationContextType = {
  currentView: string;
  setCurrentView: (view: string) => void;
};

const NavigationContext = createContext<NavigationContextType | undefined>(
  undefined,
);

type NavigationProviderProps = {
  children: ReactNode;
};

export function NavigationProvider({ children }: NavigationProviderProps) {
  const [currentView, setCurrentView] = useState('dashboard'); // Default to dashboard view

  return (
    <NavigationContext.Provider value={{ currentView, setCurrentView }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}
